"use client";

import { Phone, CirclePlus as PlusCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmergencyStormResponse() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="893" id="emergency-storm-response" className="dark bg-background text-foreground relative overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0" style={{
      background: "radial-gradient(circle at 10% 50%, hsl(75 95% 45% / 0.15) 0%, hsl(75 95% 45% / 0.05) 30%, transparent 60%)"
    }} aria-hidden="true" />

      <div ref={ref} className={`relative mx-auto max-w-7xl px-6 py-16 md:py-20 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="flex flex-col items-center gap-10 md:flex-row md:items-center md:justify-between md:gap-8">
          {}
          <div className="flex-shrink-0">
            <div className="relative flex items-center justify-center">
              <span className="absolute inline-flex h-20 w-20 rounded-md opacity-60 animate-ping" style={{
              backgroundColor: "hsl(75 95% 45% / 0.4)"
            }} aria-hidden="true" />
              <span className="absolute inline-flex h-[72px] w-[72px] rounded-md" style={{
              boxShadow: "0 0 32px 4px hsl(75 95% 45% / 0.3)"
            }} aria-hidden="true" />
              <div className="relative flex h-16 w-16 items-center justify-center rounded-md" style={{
              backgroundColor: "hsl(75 95% 45%)"
            }}>
                <PlusCircle className="h-8 w-8 text-black" strokeWidth={2.5} />
              </div>
            </div>
          </div>

          {}
          <div className="flex-1 text-center md:text-left md:px-8">
            <p className="text-xs font-mono tracking-[0.2em] uppercase mb-3" style={{
            color: "hsl(75 95% 45%)"
          }}>
              04 // RAPID RESPONSE
            </p>
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight mb-3">
              Storm damage? We respond 24/7 in DFW.
            </h2>
            <p className="text-sm md:text-base font-default text-muted-foreground max-w-2xl mx-auto md:mx-0">
              Immediate dispatch for hazardous tree removal and structural clearing. Fully insured for emergency residential recovery.
            </p>
          </div>

          {}
          <div className="flex-shrink-0 flex flex-col items-center md:items-end gap-4 w-full md:w-auto">
            <Link to="tel:+18175033131" className="font-mono text-2xl md:text-3xl lg:text-[32px] font-semibold text-foreground tracking-tighter tabular-nums hover:text-accent transition-colors" aria-label="Call (817) 503-3131">
              (817) 503-3131
            </Link>
            <Button asChild size="lg" className="w-full md:w-auto rounded-md px-8 py-6 text-base font-bold shadow-md border-none" style={{
            backgroundColor: "hsl(75 95% 45%)",
            color: "hsl(165 25% 6%)"
          }}>
              <Link to="tel:+18175033131" aria-label="Call (817) 503-3131">
                <Phone className="h-5 w-5" />
                Dispatch Now
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}